// extracted by mini-css-extract-plugin
export default {"receiptPhoto":"Capture_receiptPhoto__nOJQg","emptyField":"Capture_emptyField__SW0S3","uploadBtn":"Capture_uploadBtn__ESQmq","captureBtn":"Capture_captureBtn__N0-gJ"};